import React from 'react';
import {Tree, Menu, Dropdown, Icon, Input} from 'antd';

import GroupChildLinkCreate from './GroupChildLinkCreate'
import GroupLinkUpdate from './GroupLinkUpdate'
import GroupLinkParentUpdate from './GroupLinkParentUpdate'
import GroupLinkDelete from './GroupLinkDelete'
import {UUID_NULL} from '../constants/defaultValues'
import {locdau} from '../utils'

const TreeNode = Tree.TreeNode;
const Search = Input.Search;
class GroupTree extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      treeGroups: this.props.treeGroups,
      groups: this.props.groups,
      expandedKeys: [],
      autoExpandParent: true,
      searchValue: ''
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({groups: nextProps.groups, treeGroups: nextProps.treeGroups})
  }

  hanldeExpand = (expandedKeys) => {
    this.setState({expandedKeys, autoExpandParent: false});
  }

  handleSearch = (e) => {
    const value = e.target.value
    const {groups} = this.props
    const parentKeys = groups.filter((item) =>{
      const kodau = locdau(item.Name).toLowerCase()
      const kodauSearch = locdau(value).toLowerCase()
      return  kodau.indexOf(kodauSearch) > -1
    }).map(item => item.ParentID)
    this.setState({expandedKeys: parentKeys, autoExpandParent: true, searchValue: value})
  }

  handleCreate = (group) => {
    this.props.onCreate(group)
  }

  handleUpdate = (group) => {
    this.props.onUpdate(group)
  }

  handleDelete = (group) => {
    this.props.onDelete(group)
  }

  render() {
    const {treeGroups, groups, expandedKeys, autoExpandParent, searchValue} = this.state
    const fullTreeGroups = [...treeGroups]
    const loop = treeGroups => treeGroups.map((item)=>{
        const disabled = item.ParentID === UUID_NULL ? true : false
        const kodau = locdau(item.Name).toLowerCase()
        const kodauSearch = locdau(searchValue).toLowerCase()
        const index = kodau.indexOf(kodauSearch);
        const beforeStr = item.Name.substr(0, index);
        const matchStr = item.Name.substr(index, searchValue.length);
        const afterStr = item.Name.substr(index + searchValue.length);
        const title = index > -1 ? (
        <span>
          {beforeStr}
          <span className="highlight">{matchStr}</span>
          {afterStr}
        </span>) : <span>{item.Name}</span>;

        const menu = (
          <Menu>
            <Menu.Item key="0">
              <GroupLinkUpdate group={item} groups={groups} onUpdate={this.handleUpdate}/>
            </Menu.Item>
            <Menu.Item key="1" disabled={disabled}>
              <GroupLinkParentUpdate disabled={disabled} groups={groups} treeGroups={fullTreeGroups} group={item} onUpdate={this.handleUpdate}/>
            </Menu.Item>
            <Menu.Item key="2">
              <GroupChildLinkCreate parent={item} groups={groups} onCreate={this.handleCreate}/>
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item key="3">
              <GroupLinkDelete group={item} onDelete={this.handleDelete}/>
            </Menu.Item>
          </Menu>
        );

        if (item.Childs.length > 0) {
          return (<TreeNode title={<Dropdown overlay={menu} placement="bottomLeft" trigger={['click']}>
          <div><span className="group-name">{title}</span><Icon type="bars" /><Icon type="down" /></div>
        </Dropdown>} dataRef={item} key={item.ID}>
            {loop(item.Childs)}
          </TreeNode>);
        }
        return <TreeNode title={<Dropdown overlay={menu} placement="bottomLeft" trigger={['click']}>
        <div><span className="group-name">{title}</span><Icon type="bars" /><Icon type="down" /></div>
      </Dropdown>} dataRef={item} key={item.ID}/>;
    })
    return (<div style={{ padding: '24px 32px' }}>
      <Search style={{ marginBottom: 8, width: "100%" }} placeholder="Nhập địa bàn" onChange={this.handleSearch} />
      <Tree showLine onExpand={this.hanldeExpand} expandedKeys={expandedKeys} autoExpandParent={autoExpandParent}>
       {loop(treeGroups)}
    </Tree></div>);
  }
}

export default GroupTree



// WEBPACK FOOTER //
// ./src/components/GroupTree.js